let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jDbBU")).then(() => parcelRequire('lPGku'));